"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var TournamentInGame_1 = __importDefault(require("./TournamentInGame"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TournamentsInGame = function () {
    var t = (0, next_intl_1.useTranslations)();
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.wrapper, " ").concat(styles_module_scss_1.default.tournamentsWrapper) },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.tabTitle }, t('translation.tournaments')),
        react_1.default.createElement(TournamentInGame_1.default, null)));
};
exports.default = TournamentsInGame;
